var map = {
	"./bandito1.png": 8153,
	"./bandito10.png": 9690,
	"./bandito2.png": 9180,
	"./bandito3.png": 2235,
	"./bandito4.png": 6749,
	"./bandito5.png": 2924,
	"./bandito6.png": 1443,
	"./bandito7.png": 1090,
	"./bandito8.png": 5984,
	"./bandito9.png": 5161,
	"./cliente1.png": 2761,
	"./cliente10.png": 387,
	"./cliente2.png": 2467,
	"./cliente3.png": 1515,
	"./cliente4.png": 2442,
	"./cliente5.png": 353,
	"./cliente6.png": 8244,
	"./cliente7.png": 8155,
	"./cliente8.png": 8923,
	"./cliente9.png": 7264,
	"./porta.png": 7334,
	"./sfondo.png": 1368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2558;